export default {
    // example-api-call
    cifNumber: 'cif-number',
    fullNameApi: 'full-name-api',
    // example-custom-flow
    mandatoryOne: 'mandatory-1',
    mandatoryTwo: 'mandatory-2',
    mandatoryThree: 'mandatory-3',
    mandatoryFour: 'mandatory-4',
    mandatoryFive: 'mandatory-5',
    mandatorySix: 'mandatory-6',
    optionalOne: 'optional-1',
    optionalTwo: 'optional-2',
    // insurances
    email: 'email',
    mobile: 'mobile',
    otp: 'otp',
    noticeAddress: 'notice-address',
    appointmentSet: 'appointment-set',
    appointmentSetAddress: 'appointment-set-address',
    appointmentSetDate: 'appointment-set-date',
    appointmentPlace: 'appointment-place',
    localReference: 'localReference',
    homeCountryReference: 'homeCountryReference',
    captchaCode: 'captchaCode',
    verifyCaptcah: 'verifyCaptcah',
    // eligibility
    living: 'living',
    fixedIncomeFieldset: 'fixed-income-fieldset',
    variableIncomeFieldset: 'variable-income-fieldset',
    haveLoansOrCreditCards: 'have-loans-or-credit-cards',
    areaOfWork: 'area-of-work',
    areaOfDubai: 'area-of-dubai',
    upload: 'upload',
    fullName: 'full-name',
    fullNameReview: 'fullNameReview',
    bornDate: 'born-date',
    bornDateReview: 'born-date-review',
    nationality: 'nationality',
    gender: 'gender',
    emiratesIdInfo: 'emirates-id-info',
    emiratesIdExpiryDate: 'emirates-id-expiry-date',
    passportExpiryDateFieldSet: 'passport-expiry-date',
    passportNumberFieldSet: 'passport-number-expiry-date',
    consent: 'consent',
    employmentType: 'employment-type',
    employmentDetailsType: 'employment-details-type',
    workInformationSelfEmployed: 'work-information-self-employed',
    workInformationSalaried: 'work-information-salaried',
    incomeIbanBankAccount: 'iban-bank-account',
    bankAccount: 'bank-account',
    ibanNumber: 'iban-number',
    ibanFieldSet: 'iban-fieldset',
    bankStatementFile: 'bank-statement-file',
    instalmentsAmount: 'instalments-amount',
    residenceType: 'residence-type',
    maritalStatus: 'maritalStatus',
    doucumentDetailsType: 'document-details-type',
    consentPoliticalDetails: 'consent-political-details',
    consentPoliticalOptionDetails: 'consent-political-option-details',
    promoCodeDetails: 'promoCodeDetails',
    validateOtpFiledSet: 'validateOtpFiledSet',
    promoCodeFields: 'promoCodeFields',
    mediumOfReceiveFieldSet: 'mediumOfReceiveFieldSet',
    ibanOrStatement: 'ibanOrStatement',
    paymentHoliday: 'paymentHoliday',
    // striver-offer
    cardLimit: 'card-limit',
    paymentDate: 'payment-date',
    deliveryAddress: 'delivery-address',
    deliveryAddressReview: 'delivery-address-review',
    notice: 'notice',
    noticeDocumentation: 'notice-documentation',
    // offer
    personalInformation: 'personal-information',
    residentialAddress: 'residential-address',
    homeCountryInformation: 'home-country-information',
    references: 'references',
    referencesHomeCountry: 'references-home-country',
    employer: 'employer',
    bank: 'bank',
    amountBorrowed: 'amount-borrowed',
    amountOfInstalmentsChosen: 'amount-of-instalments-chosen',
    whatLoanFor: 'what-loan-for',
    amountBorrow: 'amount-borrow',
    amountOfInstalments: 'amount-of-instalments',
    instalmentDueDate: 'instalment-due-date',
    offerWithInsurance: 'offer-with-insurance',
    offerDisclaimer: 'offer-disclaimer',
    primaryAddress: 'primaryAddress',
    homeAddress: 'homeAddress',
    // needs-review
    salaryVerification: 'salary-verification',
    reviewReminder: 'review-reminder',
    feedback: 'feedback',
    payslipPassword: 'payslip-Password',
    payslipOnePassword: 'payslip-1-Password',
    payslipTwoPassword: 'payslip-2-Password',
    payslipThreePassword: 'payslip-3-Password',
    // Stored Value Card
    welcome: 'welcome',
    welcome2: 'welcome2',
    customerConsent: 'customerConsent',
    resendOTP: 'resentOTP',
    resendOTPProgressBar: 'resendOTPProgressBar',
    emiratesIDNumber: 'emirates-id-verification',
    emiratesIDExpiry: 'emirates-id-expiry',
    acceptOfferTerms: 'accept-offer-terms',
    nameOnCard: 'name-on-card',
    pictureOnCard: 'picture-on-card',
    consentCardAcceptance: 'consent-card-acceptance',
    setAccountPassword: 'set-account-password',
    // Credit card
    creditCardLimit: 'credit-card-limit',
    creditCardLimitReview: 'credit-card-limit-review',
    doubleSecureNotice: 'double-secure-notice',
    doubleSecureNomineeDetails: 'double-secure-nominee-details',
    // Corporate
    firstName: 'first-name',
    lastName: 'last-name',
    // Supplementary Cards
    supplementaryInfo: 'supplementary-info',
    supplementaryCards: 'supplementary-cards',
    supplementaryCardInfo: 'supplementary-card-info',
    supplementaryCardLimit: 'supplementary-card-limit',
    //Insurance
    insurance: 'insurance',
    //referalprogram
    referalFullName: 'referalFullName',
    referalEmail: 'referalEmail',
    referalMobileNumber: 'referalMobileNumber',
    referalCashUp: 'referalCashUp',
    referalMileUp: 'referalMileUp',
    referalCashUpButton: 'referalCashUpButton',
    referalMileUpButton: 'referalMileUpButton',
    applicationStatusSet: 'applicationStatusSet',
    //Balance Transfer
    balanceTransfer: 'balanceTransfer',
    firstBalanceTransfer: 'firstBalanceTransfer',
    secondCradBtTrnsfer: 'secondCradBtTrnsfer',
    thirdCradBtTrnsfer: 'thirdCradBtTrnsfer',
    fourthCradBtTrnsfer: 'fourthCradBtTrnsfer',
    btDoubleSecureNotice: 'btDoubleSecureNotice',
    addNewBtCardButton: 'addNewBtCardButton',
    saveOrCancelBt: 'saveOrCancelBt',
    btFakeRenderer: 'btFakeRenderer',
    btType: 'btType',

};